(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/information-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/information-abtest.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  Accordion = _svs$ui$ReactAccordio.Accordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const URL = svs.selfExclusion.Constants.URL;
const accordionabtest = svs.selfExclusion.accordionabtest;
const _React = React,
  useState = _React.useState;
const InformationAbTest = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  const handleChange = item => isExpanded => {
    setExpanded(isExpanded ? item : '');
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2",
    id: "readMore"
  }, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2",
    id: "qanda"
  }, "Fr\xE5gor och svar"), React.createElement(Accordion, {
    customer: "sport"
  }, accordionabtest.map(item => React.createElement(AccordionItem, {
    isExpanded: expanded === accordionabtest[item.id],
    key: item.id,
    onChange: handleChange(accordionabtest[item.id])
  }, React.createElement(AccordionSummary, null, React.createElement("h4", null, item.title)), React.createElement(AccordionDetails, null, React.createElement("p", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, item.content))))), React.createElement("div", {
    className: "more-questions-bottom"
  }, React.createElement("p", {
    className: "padding-top-2"
  }, React.createElement("strong", null, "Har du fler fr\xE5gor? "), React.createElement("a", {
    className: "fc-black",
    href: URL.CUSTOMER_SERVICE_HOME,
    rel: "noreferrer",
    target: "_blank"
  }, "Kontakta kundservice"))));
};
svs.selfExclusion.components.InformationAbTest = InformationAbTest;

 })(window);